import type { Annotation, AnnotationData, AnnotationType } from '@/services/annotationService';

export type AnnotationAnchor = { x: number; y: number };

export function moveAnnotationDataToAnchor(
  type: AnnotationType,
  data: AnnotationData,
  anchor: AnnotationAnchor,
): AnnotationData {
  const updatedData = { ...data };

  switch (type) {
    case 'line':
    case 'arrow':
    case 'measurement': {
      if (!data.start || !data.end) return updatedData;

      const currentMidX = (data.start.x + data.end.x) / 2;
      const currentMidY = (data.start.y + data.end.y) / 2;

      updatedData.start = {
        x: anchor.x + (data.start.x - currentMidX),
        y: anchor.y + (data.start.y - currentMidY),
      };
      updatedData.end = {
        x: anchor.x + (data.end.x - currentMidX),
        y: anchor.y + (data.end.y - currentMidY),
      };
      break;
    }
    case 'rectangle':
    case 'text':
    case 'image':
      updatedData.x = anchor.x;
      updatedData.y = anchor.y;
      break;
    case 'circle':
      updatedData.cx = anchor.x;
      updatedData.cy = anchor.y;
      break;
  }

  return updatedData;
}

export function moveAnnotationToAnchor(
  annotation: Annotation,
  anchor: AnnotationAnchor,
): Annotation {
  return {
    ...annotation,
    data: moveAnnotationDataToAnchor(annotation.type, annotation.data, anchor),
  };
}
